const bindPropertyMapLinks = () => {
  if (window.propertyMapLinksBound) return
  window.propertyMapLinksBound = true

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-map-address]')
    if (!link) return

    const mapIframe = document.getElementById('property-map-iframe')
    const mapContainer = document.getElementById('property-map')
    if (!mapIframe || !mapContainer) return

    const address = link.dataset.mapAddress
    if (!address) return

    event.preventDefault()

    const baseUrl = mapIframe.dataset.baseUrl || 'https://maps.google.co.jp/maps?output=embed&q='
    mapIframe.src = `${baseUrl}${encodeURIComponent(address)}`
    mapContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })
}

document.addEventListener('DOMContentLoaded', bindPropertyMapLinks)
document.addEventListener('turbolinks:load', bindPropertyMapLinks)
